module.exports = __webpack_public_path__ + "static/media/document.be71e654.svg";